import { JobStatusEnum } from '../constants'
import useSessionStatusModal from './useSessionStatusModal'
import { useSelector } from 'react-redux'
import { selectCloneLeaguesSessionByID } from '../reducers/clone_leagues_sessions'
import { selectPolledJobsByStatus, selectPolledJobsList } from '../reducers/clone_leagues_sessions_jobs_poller'
import { selectTextSearch } from '../reducers/jobs_filters'

const getProgressBarStats = (polledJobsByStatus) => {
  if (!polledJobsByStatus) {
    return { totalJobsCount: 0, processedJobsCount: 0, percentage: 0}
  }

  let totalJobsCount = 0

  Object.values(JobStatusEnum).forEach(status => {
    const jobsData = polledJobsByStatus?.[status]

    if (jobsData) {
      totalJobsCount += Object.keys(jobsData).length
    }
  })

  const processedJobsCount = Object.keys(polledJobsByStatus?.[JobStatusEnum.COMPLETED]).length
  const percentage = processedJobsCount * 100 / totalJobsCount

  return { totalJobsCount, processedJobsCount, percentage }
}

const useSessionStatusData = () => {
  const { sessionID } = useSessionStatusModal()
  const currentSession = useSelector(selectCloneLeaguesSessionByID(sessionID))
  const targetJobIDs = currentSession?.job_ids
  const jobsFiltersTextSearch = useSelector(selectTextSearch)

  const polledJobsByStatus = useSelector(selectPolledJobsByStatus(targetJobIDs))

  let polledJobsList = useSelector(selectPolledJobsList(targetJobIDs)) || []
  polledJobsList = polledJobsList.filter(
    job => job?.parameters?.league_name?.toLowerCase().includes(jobsFiltersTextSearch.toLowerCase())
  )

  const { totalJobsCount, processedJobsCount, percentage } = getProgressBarStats(polledJobsByStatus)

  return {
    currentSession,
    sessionID,
    totalJobsCount,
    processedJobsCount,
    percentage,
    polledJobsByStatus,
    polledJobsList,
  }
}

export default useSessionStatusData
